import {LifeProject} from './life-project';
import {AssetResource} from './asset-resource';

export class BuildMoneyProject extends LifeProject {
  futureValue: number;
  type = 3;
}
